
import React from "react";
import { Filter } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";

interface SolutionFiltersProps {
  selectedAgency: string;
  setSelectedAgency: (agency: string) => void;
  commercialType: string;
  setCommercialType: (type: string) => void;
}

const SolutionFilters: React.FC<SolutionFiltersProps> = ({
  selectedAgency,
  setSelectedAgency,
  commercialType,
  setCommercialType,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Filter className="h-4 w-4" />
          Filters
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <label className="text-sm font-medium">Agency</label>
          <Select value={selectedAgency} onValueChange={setSelectedAgency}>
            <SelectTrigger>
              <SelectValue placeholder="Select Agency" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Agencies</SelectItem>
              <SelectItem value="GSA">General Services Administration</SelectItem>
              <SelectItem value="Education">Department of Education</SelectItem>
              <SelectItem value="NOAA">National Oceanic and Atmospheric Administration</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium">Commercial Type</label>
          <Select value={commercialType} onValueChange={setCommercialType}>
            <SelectTrigger>
              <SelectValue placeholder="Select Type" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Sale">Sale</SelectItem>
              <SelectItem value="Lease">Lease</SelectItem>
              <SelectItem value="Collaborate">Collaborate</SelectItem>
              <SelectItem value="Stake">Stake</SelectItem>
            </SelectContent>
          </Select>
          <div className="text-xs text-gray-500 mt-1">
            <p>Sale: 100% of base price</p>
            <p>Lease: 10% of base price</p>
            <p>Collaborate: 20% of base price</p>
            <p>Stake: 50% of base price</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SolutionFilters;
